import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    apellido: '',
    nombre: '',
    documentoTipoId: 0,
    documentoTipo: null,
    documentoTipoNombre: null,
    documentoNumero: '',
    fechaNacimiento: new Date(),
    fechaNacimientoHijoHabilitada: false,
    // rowVersion: null,
};

const mutations = {
    updateField,

    'INICIALIZAR' (state) {
        let fecha = moment(new Date('01/01/1900')).format('YYYY-MM-DD');

        state.id = 0;
        state.apellido = '';
        state.nombre = '';
        state.documentoTipoId = 0;
        state.documentoTipo = null;
        state.documentoTipoNombre = null;
        state.documentoNumero = '',
        state.fechaNacimiento = fecha;
        state.fechaNacimientoHijoHabilitada = false;
        state.rowVersion = null;
    },
    'SET_PERSONAL_HIJO' (state, personalHijo) {
        // console.log(personalHijo);
        state.id= personalHijo.id;
        state.apellido = personalHijo.apellido.trim();
        state.nombre = personalHijo.nombre.trim();
        state.documentoTipoId = personalHijo.documentoTipo? parseInt(personalHijo.documentoTipo.id) : 0;
        state.documentoTipo = personalHijo.documentoTipo;
        state.documentoTipoNombre = personalHijo.documentoTipo? personalHijo.documentoTipo.nombre.trim() : null;
        state.documentoNumero = personalHijo.documentoNumero.trim();
        state.fechaNacimiento = moment(personalHijo.fechaNacimiento).format('YYYY-MM-DD');
        if (moment(personalHijo.fechaNacimiento).format('YYYY-MM-DD') != '1900-01-01') {
            state.fechaNacimientoHijoHabilitada = true;
        } else {
            state.fechaNacimientoHijoHabilitada = false;   
        }
    },
    'SET_DOCUMENTO_TIPO'(state, documentoTipo) {
        state.documentoTipo = documentoTipo;
        state.documentoTipoId = (documentoTipo) ? documentoTipo.id : 0;
        state.documentoTipoNombre = (documentoTipo) ? documentoTipo.nombre.trim() : null;
    },
};

function getAge(dateString) {
    if (dateString == '1900-01-01') {
        return 0;
    }

    let today = new Date();
    let birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    let m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

const getters = {
    getField,

    personalHijo(state) {
        let fechaNacimiento = '1900-01-01';
        if ((/true/i).test(state.fechaNacimientoHijoHabilitada)) {
            fechaNacimiento = moment(state.fechaNacimiento).format('YYYY-MM-DD');
        }

        return {
            // id: state.id,
            apellido: state.apellido.toUpperCase().trim(),
            nombre: state.nombre.toUpperCase().trim(),
            documentoTipoId: parseInt(state.documentoTipoId),
            documentoTipo: state.documentoTipo,
            documentoNumero: state.documentoNumero,
            fechaNacimiento: fechaNacimiento,
            edad: getAge(fechaNacimiento)
        }
    }
};

const actions = {
    inicializar ( { commit }, personalHijo ) {
        return new Promise((resolve, reject) => { 
            commit('INICIALIZAR');

            if (personalHijo)
            {
                commit('SET_PERSONAL_HIJO', personalHijo);
                resolve();
            } else {
                resolve();
            }
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let fechaNacimiento = '1900-01-01';
            if ((/true/i).test(state.fechaNacimientoHijoHabilitada)) {
                fechaNacimiento = moment(state.fechaNacimiento).format('YYYY-MM-DD');
            }

            resolve();
        })
    },
    setDocumentoTipo: ({commit}, documentoTipo) => {
        commit('SET_DOCUMENTO_TIPO', documentoTipo);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}